module.exports = __webpack_public_path__ + "img/telephone-x-fill.6204ed45.svg";